import React, { Children, useState, useEffect } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { useMediaQuery, breakpoints } from "../hooks/useMediaQuery";
import Step from "./Step";
import IndicatorContext from "./StepIndicatorContext";

import styles from "./StepIndicator.scss";

export function StepIndicator({
  currentStep,
  onStepChange,
  children: steps,
  hideLabelUntil,
  allowUserClick,
  preventIncompleteStepClick,
  customClass,
  ...restProps
}) {
  const [highestCompletedStep, setHighestCompletedStep] = useState(currentStep);
  const totalSteps = Children.count(steps);
  const isNarrow = totalSteps <= 4;
  const isLabelHidden = useMediaQuery(`(max-width: ${hideLabelUntil}px)`);

  useEffect(() => {
    if (currentStep > highestCompletedStep) {
      setHighestCompletedStep(currentStep);
    }
  }, [currentStep]);

  return (
    <div
      className={cx(styles.container, customClass, {
        [styles.containerNarrow]: isNarrow,
        [styles.hideLabel]: isLabelHidden,
      })}
      {...restProps}
    >
      <IndicatorContext.Provider
        value={{
          onStepChange,
          currentStep,
          isNarrow,
          allowUserClick,
          preventIncompleteStepClick,
          highestCompletedStep,
        }}
      >
        {steps}
      </IndicatorContext.Provider>
    </div>
  );
}

StepIndicator.Step = Step;

StepIndicator.propTypes = {
  onStepChange: PropTypes.func,
  currentStep: PropTypes.number.isRequired,
  hideLabelUntil: PropTypes.number,
  allowUserClick: PropTypes.bool,
  preventIncompleteStepClick: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  customClass: PropTypes.string,
};

StepIndicator.defaultProps = {
  onStepChange: null,
  children: "",
  hideLabelUntil: breakpoints.l,
  allowUserClick: false,
  preventIncompleteStepClick: false,
  customClass: null,
};

StepIndicator.displayName = "StepIndicator";

export default StepIndicator;
